
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/location-service",
      function () {
        return require("private-next-pages/policy/location-service.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/location-service"])
      });
    }
  